import { Theme } from "@mui/material";
import { msaTheme } from "./msaTheme";
import { amfamTheme } from "./afiTheme";

export enum ThemeIdentifiers {
  AMFAM_THEME_ID = "C46502ED595BAD41",
  MSA_THEME_ID = "D8958C3071714434",
}

export default function getThemeById(opcoId: string): Theme {
  let themeName = "";
  switch (opcoId) {
    case ThemeIdentifiers.AMFAM_THEME_ID:
      themeName = "amfamTheme";
      break;
    case ThemeIdentifiers.MSA_THEME_ID:
      themeName = "msaTheme";
      break;
    default:
      break;
  }
  return themeMap[themeName];
}

const themeMap: { [key: string]: Theme } = {
  msaTheme,
  amfamTheme,
};
